export const RideType = {
  NEW: "NEW",
  ASSIGNED: "ASSIGNED",
  EN_ROUTE: "EN_ROUTE",
  ON_LOCATION: "ON_LOCATION",
  MADE_PICKUP: "MADE_PICKUP",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
  NO_SHOW: "NO_SHOW",
};

export const RideTypeMeta = {
  NEW: {
    title: 'Upcoming',
    color: '#2E4BB5',
  },
  ASSIGNED: {
    title: 'Dispatched',
    color: '#2E4BB5',
  },
  EN_ROUTE: {
    title: 'En route',
    color: '#2E4BB5',
  },
  ON_LOCATION: {
    title: 'On location',
    color: '#2E4BB5',
  },
  MADE_PICKUP: {
    title: 'In progress',
    color: '#2E4BB5',
  },
  COMPLETED: {
    title: 'Completed',
    color: '#00844D',
  },
  CANCELED: {
    title: 'Canceled',
    color: '#E1292D',
  },
  NO_SHOW: {
    title: 'No-show',
    color: '#E1292D',
  },
  UNKNOWN: {
    title: 'Unknown',
    color: '#B3B3B3',
  },
};
